"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _consts = require("../consts.js");
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint-disable no-case-declarations */
var CheckoutIntentOOI = /*#__PURE__*/function (_Component) {
  function CheckoutIntentOOI(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleCheckoutMessageReceived = _this.handleCheckoutMessageReceived.bind(_this);
    _this.updateItems = _this.updateItems.bind(_this);
    return _this;
  }
  _inheritsLoose(CheckoutIntentOOI, _Component);
  var _proto = CheckoutIntentOOI.prototype;
  _proto.handleCheckoutMessageReceived = function handleCheckoutMessageReceived(type, payload, resolve, reject, providerId) {
    var _this$props = this.props,
      artStoreApi = _this$props.artStoreApi,
      cartItems = _this$props.cartItems;
    switch (type) {
      case _providerEvents["default"].sdkReady:
        this.updateItems();
        break;
      case _providerEvents["default"].updateCartItem:
        // checkout cant update cart item
        // artStoreApi.updateCartItem({
        //   uuid: payload.uuid,
        //   metadata: payload.metadata,
        //   quantity: payload.quantity,
        // });
        break;
      case _providerEvents["default"].backHome:
        var openCart = payload && payload.openCart;
        this.props.onClose(openCart);
        break;
      case _providerEvents["default"].clearCart:
        artStoreApi.clearCart();
        break;
      case _providerEvents["default"].removeFromCart:
        artStoreApi.removeFromCart({
          uuid: payload.uuid
        });
        break;
      case _providerEvents["default"].getCartItems:
        var items = cartItems || [];
        resolve(items);
        break;
      default:
        break;
    }
  };
  _proto.updateItems = function updateItems() {
    if (this.intent) {
      var cartItems = this.props.cartItems;
      this.intent.postMessage(_providerEvents["default"].refreshCart, cartItems);
    }
  };
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var cartItems = nextProps.cartItems;
    if (this.intent && cartItems) {
      var _cartItems = nextProps.cartItems;
      this.intent.postMessage(_providerEvents["default"].refreshCart, _cartItems);
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      connectedProviders = _this$props2.connectedProviders,
      wixSdk = _this$props2.wixSdk,
      locale = _this$props2.locale,
      deviceType = _this$props2.deviceType,
      viewMode = _this$props2.viewMode,
      checkoutParams = _this$props2.checkoutParams,
      additionalProviderParams = _this$props2.additionalProviderParams,
      consentPolicy = _this$props2.consentPolicy;
    var customAdditionalParams = _objectSpread({}, checkoutParams);
    consentPolicy && (customAdditionalParams.consentPolicy = consentPolicy);
    if (additionalProviderParams) {
      var srcId = additionalProviderParams.srcId,
        appDefId = additionalProviderParams.appDefId,
        isAlbumStore = additionalProviderParams.isAlbumStore;
      srcId && (customAdditionalParams.srcId = srcId);
      appDefId && (customAdditionalParams.appDefId = appDefId);
      isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
    }
    var renderComponent = /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], {
      api: new _WixSDKProviderApi["default"](wixSdk),
      hiddenFromEditor: true,
      ref: function ref(element) {
        return _this2.intent = element;
      },
      intent: _consts.providerIntents.checkout,
      onMessageReceived: this.handleCheckoutMessageReceived,
      additionalParams: {},
      customAdditionalParams: customAdditionalParams,
      connectedProviders: connectedProviders,
      locale: locale,
      deviceType: deviceType,
      viewMode: viewMode,
      appInstance: this.props.appInstance,
      onIframeLoaded: this.updateItems
    });
    return renderComponent;
  };
  return CheckoutIntentOOI;
}(_react.Component);
var _default = exports["default"] = CheckoutIntentOOI;